<template>
  <BouyguesError v-if="error" @try-again="refreshOffers" />

  <PhonelineSetupForm
    v-if="priceOptions?.keepPhoneNumber && priceOptions?.newPhoneNumber"
    :keep-phone-number-price-option="priceOptions.keepPhoneNumber"
    :new-phone-number-price-option="priceOptions.newPhoneNumber"
  />
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed, onMounted } from 'vue'

import {
  getOfferPriceOptions,
  useBouyguesOffers,
} from '~/composables/useBouyguesOffers'
import BouyguesError from '~/scopes/checkout/components/BouyguesError/BouyguesError.vue'
import { useBouyguesStore } from '~/scopes/checkout/stores/bouyguesStore'

import PhonelineSetupForm from './components/PhonelineSetupForm/PhonelineSetupForm.vue'

const { offers, error, refresh: refreshOffers } = await useBouyguesOffers()
const { setAuthorizationCode } = useBouyguesStore()
const route = useRoute()

onMounted(() => {
  if (route.query?.code && typeof route.query.code === 'string') {
    setAuthorizationCode(route.query.code)
  }
})

const priceOptions = computed(() => {
  if (!offers.value) return null

  // TODO: B2CS-124: Replace the `offers.value[0].name` with actual offer on cart
  return getOfferPriceOptions(offers.value, offers.value[0].name)
})
</script>
